module.exports = __webpack_public_path__ + "static/img/4.01a82be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/eng/4.png
// module id = sNYz
// module chunks = 0